import React from "react"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { cn } from "~/ui-rtk/utils/tailwind-utils"

interface SortableModalItemProps {
  id: string
  title: string
}

const SortableModalItem: React.FC<SortableModalItemProps> = ({ id, title }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={cn(
        "flex items-center justify-between p-4 bg-system-blue-800 border border-system-blue-600 rounded-system-md mb-2 cursor-grab active:cursor-grabbing",
        "hover:bg-system-blue-700 hover:border-system-blue-500 transition-colors duration-150",
        isDragging &&
          "opacity-60 shadow-xl z-50 bg-system-blue-700 border-system-blue-500",
      )}
      title="Drag to reorder"
    >
      <div className="flex items-center space-x-3">
        <div className="flex items-center justify-center w-6 h-6 bg-system-blue-600 rounded-system-xs">
          <svg
            className="w-3 h-3 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 8h16M4 16h16"
            />
          </svg>
        </div>
        <span className="text-white font-medium pointer-events-none select-none">
          {title}
        </span>
      </div>
    </div>
  )
}

export default SortableModalItem
